import { reactive } from "vue";
import { io } from "socket.io-client";

export const state = reactive({
    connected: false,
    fooEvents: [],
    barEvents: []
});

const socketUrl = process.env.VUE_APP_API_BASE;

export const socket = io(socketUrl, {});

socket.on("connect", () => {
    state.connected = true;
    socket.emit("join", {room: 'frontend'});

});

socket.on("disconnect", () => {
    state.connected = false;
});
